// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "html.-app-is-ready{scroll-behavior:smooth}.app,.page{position:relative}.page{width:100%;z-index:1}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
